document.addEventListener('DOMContentLoaded', function () {
	new AccessibleMenu.DisclosureMenu({
		menuElement: document.getElementById('primary-nav-menu'),
		submenuItemSelector: 'li.dropdown',
		hoverType: 'on',
		openClass: 'is-open',
		closeClass: 'is-closed',
	});

	new AccessibleMenu.DisclosureMenu({
		menuElement: document.querySelector('#secondary-nav ul'),
		submenuItemSelector: 'li.dropdown',
		hoverType: 'on',
		openClass: 'is-open',
		closeClass: 'is-closed',
	});
});

/*new AccessibleMenu.Treeview({
	menuElement: document.getElementById('sidebar-nav'),
	submenuItemSelector: 'li.dropdown',
	openClass: 'is-open',
	closeClass: 'is-closed',
});*/